<span
  placement="left"
  class="initial-payment"
  [ngbTooltip]="productDescriptionTooltip"
  tooltipClass="custom-tooltip fees-tooltip"
>
  {{ product.initialMonthlyPayment | currency: 'GBP':'symbol':'1.2-2' }}
</span>

<ng-template #productDescriptionTooltip>
  <div class="tooltip-content">
    <p><strong>Initial Monthly Payment</strong></p>
    <div>First {{ product.delayedStart }} months: £0</div>
    <div>Following {{ product.initialPeriod - product.delayedStart }} months: {{ product.initialMonthlyPayment | currency: 'GBP':'symbol':'1.2-2' }}</div>
  </div>
</ng-template>
